import { Component, Input } from '@angular/core';

import { SessionService } from '../../shared/services/session.service';

@Component({
  selector: 'app-app-list',
  templateUrl: './app-list.component.html',
  styleUrls: ['./app-list.component.css']
})
export class AppListComponent {
  @Input() apps: any[] = [];

  constructor(private sessionService: SessionService) {}

  /** Append the SSO session as a `#session=` fragment so the target app auto-logs in. */
  buildLaunchUrl(appUrl: string): string {
    return this.sessionService.buildLaunchUrl(appUrl);
  }
}
